import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Header from '../Header';


const ProgramDetails = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  // Get base URL based on environment
  const baseURL = process.env.REACT_APP_NODE_ENV === 'development'
    ? process.env.REACT_APP_DEVELOPMENT_BASE_URL
    : process.env.REACT_APP_PRODUCTION_BASE_URL;

  useEffect(() => {
    fetchProgramDetails();
  }, [id]);



  useEffect(() => {
    if (program && program.programTypes) {
      let parsedProgramTypes = {};

      try {
        // Parse if it's a string
        if (typeof program.programTypes === "string") {
          parsedProgramTypes = JSON.parse(program.programTypes);
        } else if (typeof program.programTypes === "object" && program.programTypes !== null) {
          parsedProgramTypes = program.programTypes;
        }
      } catch {
        parsedProgramTypes = {};
      }

      // Find first program type with facilities
      const firstAvailableType = Object.entries(parsedProgramTypes)
        .find(([type, data]) => data.facilities && data.facilities.length > 0)?.[0];

      if (firstAvailableType) {
        setActiveTab(firstAvailableType);
      }
    }
  }, [program]);


  const fetchProgramDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseURL}/api/course/${id}`);

      console.log("response", response)
      if (response.data.success) {
        setProgram(response.data.data);
      }
    } catch (err) {
      setError('Failed to fetch program details');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleContinueRegistration = () => {
    navigate(`/${id}/registration`, {
      state: {
        programPrice: program.programPrice,
        programName: program.programName
      },
    });
  };

  const renderContent = () => {
    if (loading) {
      return <div className="loading-spinner">Loading...</div>;
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    if (!program) {
      return <div className="error-message">Program not found</div>;
    }


    let programTypes = {};

    try {
      if (typeof program.programTypes === "string") {
        programTypes = JSON.parse(program.programTypes);
      } else if (typeof program.programTypes === "object" && program.programTypes !== null) {
        programTypes = program.programTypes;
      }
    } catch {
      programTypes = {};
    }

    console.log("programTypes", programTypes)
    return (
      <section className="who_is_good program_details">
        <div className="container">
          {/* <button className="back-button" onClick={handleBack}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7"/>
                        </svg>
                        Back to Programs
                    </button> */}
          <div className="row mt-4">
            <div className="col-lg-6 mb-3 mb-md-0">
              <div className="position-stick-top">
                <h4>{program.programName}</h4>
                <div className="mb-3">
                  <p className="w-100">{program.programDescription}</p>
                </div>
                <div className="program-price mb-3">
                  <span className="price-label">Program Price:</span>
                  <span className="price-amount">${parseFloat(program.programPrice).toFixed(2)}</span>
                </div>
                <button
                  className={`btn1 ${location.pathname.includes('dashboard') ? 'disabled d-none' : ''}`}
                  onClick={handleContinueRegistration}
                  disabled={location.pathname.includes('dashboard')}
                >
                  Enroll Now
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content">
                <div>
                  {/* Tabs Navigation */}
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {Object.entries(programTypes)
                      .filter(([, data]) => data.enabled)
                      .sort(([, a], [, b]) => (a.sequence || 0) - (b.sequence || 0))
                      .map(([type, data]) => {
                        // normalize key for consistent matching
                        const normalizedType = type.toLowerCase();

                        const typeLabels = {
                          program: "Program",
                          elearning: "E-Learning",
                          classroom: "Classroom",
                        };

                        return data.facilities && data.facilities.length > 0 ? (
                          <li key={type} className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${type === activeTab ? "active" : ""}`}
                              id={`${type}-tab`}
                              data-bs-toggle="tab"
                              data-bs-target={`#${type}`}
                              type="button"
                              role="tab"
                              aria-controls={type}
                              aria-selected={type === activeTab}
                              onClick={() => setActiveTab(type)}
                            >
                              {typeLabels[normalizedType] ||
                                normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1)}
                            </button>
                          </li>
                        ) : null;
                      })}
                  </ul>


                  {/* Tabs Content */}
                  <div className="tab-content mt-3" id="myTabContent">
                    {Object.entries(programTypes).map(([type, data]) =>
                      data.facilities && data.facilities.length > 0 ? (
                        <div
                          key={type}
                          className={`tab-pane fade ${type === activeTab ? "show active" : ""}`}
                          id={type}
                          role="tabpanel"
                          aria-labelledby={`${type}-tab`}
                        >
                          {data.facilities.map((facility, facilityIndex) => (
                            <div key={facilityIndex} className="text">
                              <div>
                                <span>{facilityIndex + 1}</span>
                              </div>
                              <h6>{facility}</h6>
                            </div>
                          ))}
                        </div>
                      ) : null
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <>
      <Header />
      {renderContent()}
    </>
  );
};

export default ProgramDetails; 